appHost.actions.register({
    // #region Vars
    name: '288a.identity.user.changename',
    // #endregion
    // #region Entry
    async execute(data, params) {
        return this.Window(await appHost.notification.showModal2("g-account-username_change"));
    },
    // #endregion
});
export {};
